import { fetchAPI } from "./utils";

export interface VoiceClone {
    id: string;
    name: string;
    description?: string;
    externalVoiceId?: string;
    gender?: string;
    accent?: string;
    age?: string;
    languageAIId?: string;
    origin?: string;
    status: string;
    requiresVerification: boolean;
    createdAt: string;
    updatedAt: string;
}

export interface VoiceCloneStats {
    used: number;
    limit: number;
    remaining: number;
    canCreateMore: boolean;
}

export interface CreateVoiceCloneParams {
    token: string;
    name: string;
    description?: string;
    audioUrls: string[];
    gender?: string;
    accent?: string;
    age?: string;
    language?: string;
}

export interface CreateVoiceCloneResponse {
    voiceClone: VoiceClone;
    error?: string;
}

/**
 * Get voice clone statistics (used, remaining, etc.)
 */
export const getVoiceCloneStats = async (token: string): Promise<VoiceCloneStats> => {
    return fetchAPI<VoiceCloneStats>("/voice-clone-stats", "GET", undefined, token);
};

/**
 * Create a new voice clone
 */
export const createVoiceClone = async ({
    token,
    name,
    description,
    audioUrls,
    gender,
    accent,
    age,
    language,
}: CreateVoiceCloneParams): Promise<CreateVoiceCloneResponse> => {
    return fetchAPI<CreateVoiceCloneResponse>(
        "/create-voice-clone",
        "POST",
        {
            name,
            description,
            audioUrls,
            gender,
            accent,
            age,
            language,
        },
        token,
    );
};

/**
 * Get all voice clones for the current user
 */
export const getVoiceClones = async (token: string): Promise<VoiceClone[]> => {
    return fetchAPI<VoiceClone[]>("/get-voice-clones", "GET", undefined, token);
};
